module.exports = __webpack_public_path__ + "static/img/5.268651e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/5.jpg
// module id = ih2U
// module chunks = 5